import React, { Component } from 'react'
import { withRouteData } from 'react-static'
import queryString from 'query-string'

class TrackAndGo extends Component {
    redirectTo() {
        var paramUrl = queryString.parse(document.location.search).url

        window.location.replace(paramUrl ? paramUrl : this.props.redirectUrl)
    }

    componentDidMount() {
        this.redirectTo()
    }

    render() {
        return (
            ''
        )
    }
}

export default withRouteData(({ url }) => (
    <TrackAndGo redirectUrl={url} />
))



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/TrackAndGo.jsx